<template>
  <div class="footer-contact-column-2 footer-contact-column caption">
    <div class="column-header">
      <div class="header-icon">
        <img src="../assets/icons/arrow-right-black-extended.svg" alt="">
      </div>
      <div class="overline">{{$t('footer.social_media')}}</div>
    </div>
    <div class="info-row">
      <div class="icon-container">
        <img src="../assets/icons/linkedin-icon.svg" alt="">
      </div>
      <a href="https://www.linkedin.com/company/swiss-engineers-united" target="_blank">Linkedin</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterContactColumn2",

}
</script>

<style lang="scss">
@import "FooterContactColumn2.scss";
</style>
